import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import Dialog from '../../atoms/feedback/Dialog'
import Label from '../../atoms/display/Label'
import { FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import { CompanyRepresentative } from '../../../types/Company'
import { CompanyActions } from '../../../store/company'

type Props = {
  open: boolean
  representative: CompanyRepresentative
  onClose: () => void
}

export default function CompanyRepresentativeAcceptDialog({ open, representative, onClose }: Props) {
  const dispatch = useDispatch()

  const handleAccept = useCallback(() => {
    dispatch(
      CompanyActions.acceptRepresentative({
        companyId: representative.company.id,
        representativeId: representative.id,
      })
    )
    onClose()
  }, [dispatch, onClose, representative])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="本人確認の承認"
      actions={
        <FlexRow>
          <Button variant="text" onClick={onClose}>
            キャンセル
          </Button>
          <Button onClick={handleAccept}>承認</Button>
        </FlexRow>
      }
    >
      <Label text="本人確認を承諾しますか？" />
    </Dialog>
  )
}
